module.exports = __webpack_public_path__ + "static/media/datepicker.05164a52.png";